/**
 * bootprompt.js locale configuration
 * locale : Arabic
 * author : Emad Omar
 */

import { addLocale } from "../bootprompt";

addLocale("ar", {
  OK: "موافق",
  CANCEL: "الغاء",
  CONFIRM: "تأكيد",
});
